export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Further remarks?",
			},
			{
				id: 2,
				text: "Which topics would you like to have covered in future courses?",
			},
		],
	},
	{
		type: "uni",
		title: "Note: Please only mark items that apply to this course. Unfitting items may remain unmarked.",
		id: 2,
		items: [
			{
				id: 3,
				text: "The competence objectives became clear to me.",
			},
			{
				id: 4,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 5,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 6,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 7,
				text: "I was encouraged to interact with other participants throughout the course.",
			},
			{
				id: 8,
				text: "The individual or group activities were useful.",
			},
			{
				id: 9,
				text: "I was encouraged to think about the contents of the course.",
			},
		],
	},
	{
		type: "bi",
		id: 3,
		items: [
			{
				id: 10,
				text: "The amount of the content was adequate.",
			},
			{
				id: 11,
				text: "The pace of the course was adequate.",
			},
			{
				id: 12,
				text: "The requirements of the course were adequate.",
			},
		],
	},
	{
		type: "uni",
		id: 4,
		items: [
			{
				id: 13,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 14,
				text: "Overall, this was a good course.",
			},
			{
				id: 15,
				text: "I would recommend the course.",
			},
			{
				id: 16,
				text: "The lecturer was motivating.",
			},
			{
				id: 17,
				text: "I felt properly guided through the course.",
			},
			{
				id: 18,
				text: "The lecturer provided a good working atmosphere.",
			},
			{
				id: 19,
				text: "The lecturer provided the opportunity to actively participate in the course.",
			},
			{
				id: 20,
				text: "The lecturer was able to adequately and flexibly respond to the participants’ wishes and needs.",
			},
			{
				id: 21,
				text: "The lecturer was very competent.",
			},
			{
				id: 22,
				text: "The lecturer was able to mediate.",
			},
			{
				id: 23,
				text: "The skills provided in the course are of great relevance for my professional or university career and/or my individual development",
			},
			{
				id: 24,
				text: "I believe that I have improved or consolidated important skills in the course.",
			},
			{
				id: 25,
				text: "I have ideas how to transfer the topic to practical applications.",
			},
			{
				id: 26,
				text: "I had the opportunity to reflect my own contents and concerns.",
			},
		],
	},
	{
		type: "age",
		id: 5,
		items: [
			{
				id: 27,
				text: "Age: ",
			},
		],
	},
	{
		type: "special",
		id: 6,
		items: [
			{
				id: 28,
				text: "I am a ",
				label: [
					{
						id: 1,
						text: "Lecturer",
					},
					{
						id: 2,
						text: "Student",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 7,
		items: [
			{
				id: 29,
				text: "Your current semester (if student)",
				type: "small",
			},
			{
				id: 30,
				text: "Desired degree (if student)",
				type: "medium",
			},
		],
	},
];
